
import Vue from "vue";
import filters from "@/filters";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import NewsItem1 from "@/components/items/news/NewsItem1.vue";

@Component({
  components: {
    NewsItem1,
  },
  filters,
})
export default class News1 extends Vue {
  @Prop({ default: [] })
  private news!: Array<any>;
  @Prop({ default: "" })
  private title!: string;
}
